var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlowingMapPop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 114,
    viewBox: "0 0 114 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9,
    filter: "url(#filter0_f_2637_3131)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 57,
    r: 17,
    fill: "#90F50F"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2637_3131)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_2637_3131",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.802 52.2771C70.1474 50.4203 69.9856 47.8054 68.3167 46.136C66.5114 44.3303 63.6163 44.2792 61.7515 45.9912V45.7527C61.7515 43.1294 59.6227 41 57 41C54.3773 41 52.2485 43.1294 52.2485 45.7527V45.9912C50.3837 44.2877 47.4886 44.3303 45.6833 46.136C44.0059 47.8139 43.8441 50.4203 45.198 52.2771C42.8393 52.5496 41 54.5598 41 56.9957C41 59.6191 43.1288 61.7485 45.7515 61.7485H45.9899L45.6919 62.0466C43.8356 63.9034 43.8356 66.91 45.6919 68.7668C47.5056 70.581 50.4348 70.6236 52.2911 68.869C52.5977 71.1943 54.5902 73 57 73C59.4098 73 61.4023 71.2028 61.7089 68.869C63.5737 70.6151 66.4944 70.581 68.3081 68.7668C70.1645 66.91 70.1645 63.9034 68.3081 62.0466L68.0101 61.7485H68.2485C70.8712 61.7485 73 59.6191 73 56.9957C72.9915 54.5598 71.1607 52.5496 68.802 52.2771Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M68.802 52.2771C70.1474 50.4203 69.9856 47.8054 68.3167 46.136C66.5114 44.3303 63.6163 44.2792 61.7515 45.9912V45.7527C61.7515 43.1294 59.6227 41 57 41C54.3773 41 52.2485 43.1294 52.2485 45.7527V45.9912C50.3837 44.2877 47.4886 44.3303 45.6833 46.136C44.0059 47.8139 43.8441 50.4203 45.198 52.2771C42.8393 52.5496 41 54.5598 41 56.9957C41 59.6191 43.1288 61.7485 45.7515 61.7485H45.9899L45.6919 62.0466C43.8356 63.9034 43.8356 66.91 45.6919 68.7668C47.5056 70.581 50.4348 70.6236 52.2911 68.869C52.5977 71.1943 54.5902 73 57 73C59.4098 73 61.4023 71.2028 61.7089 68.869C63.5737 70.6151 66.4944 70.581 68.3081 68.7668C70.1645 66.91 70.1645 63.9034 68.3081 62.0466L68.0101 61.7485H68.2485C70.8712 61.7485 73 59.6191 73 56.9957C72.9915 54.5598 71.1607 52.5496 68.802 52.2771Z",
    fill: "#90F50F",
    stroke: "#232323",
    strokeWidth: 2,
    mask: "url(#path-2-inside-1_2637_3131)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2637_3131",
    x: 0,
    y: 0,
    width: 114,
    height: 114,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20,
    result: "effect1_foregroundBlur_2637_3131"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2637_3131",
    x: 37,
    y: 41,
    width: 40,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2637_3131"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2637_3131",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlowingMapPop);
export default __webpack_public_path__ + "static/media/glowing_map_pop.84abed062cf05c1cb2b708637ecf9661.svg";
export { ForwardRef as ReactComponent };